// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {

  --fontFamily: Roboto, sans-serif;
  --mainBackground: #fff;
  --dimBackground: #f9fafb;
  --mainForeground: #262626;
  --dimForeground: #6d7283;
  --primaryForeground: #315efb;
  --successForeground: #28bc00;
  --warningForeground: #f4c914;
  --failureForeground: #ff564e;
  --lightGrayBlue: #e8eaf0;
  --greyishBlue: #6674a6;
  --cloudGray: #8d96b2;
  --battleshipGrey: #62687f;
  --carbone: #343b4c;
}

.src-components-PopupButtons-styles--root--cwfSr {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}

@media screen and (max-width: 767.98px) {

.src-components-PopupButtons-styles--root--cwfSr {
    flex-wrap: wrap;
}
  }

.src-components-PopupButtons-styles--root--cwfSr > button {
    flex-grow: 1;
    width: 100%;
  }

@media screen and (min-width: 768px) {

.src-components-PopupButtons-styles--root--cwfSr > button {
      width: calc(50% - 10px);
  }
    }

@media screen and (max-width: 767.98px) {

.src-components-PopupButtons-styles--root--cwfSr > button + button {
      margin-left: 0;
      margin-top: 15px;
  }
    }

@media screen and (min-width: 768px) {

.src-components-PopupButtons-styles--root--cwfSr > button + button {
      margin-left: 20px;
      margin-top: 0;
  }
    }
`, "",{"version":3,"sources":["webpack://./src/utils/variables.css","webpack://./src/components/PopupButtons/styles.css"],"names":[],"mappings":"AAAA;;EAQE,gCAAgC;EAChC,sBAAsB;EACtB,wBAAwB;EACxB,yBAAyB;EACzB,wBAAwB;EACxB,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,wBAAwB;EACxB,sBAAsB;EACtB,oBAAoB;EACpB,yBAAyB;EACzB,kBAAkB;AACpB;;ACpBA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;AA0BlB;;AAxBE;;AALF;IAMI,eAAe;AAuBnB;EAtBE;;AAEA;IACE,YAAY;IACZ,WAAW;EAKb;;AAHE;;AAJF;MAKI,uBAAuB;EAE3B;IADE;;AAIA;;AADF;MAEI,cAAc;MACd,gBAAgB;EAOpB;IANE;;AAEA;;AANF;MAOI,iBAAiB;MACjB,aAAa;EAEjB;IADE","sourcesContent":[":root {\n  @custom-media --mobile screen and (width < 768px);\n  @custom-media --desktop screen and (width >= 768px);\n  @custom-media --desktop-l screen and (width >= 1024px);\n  @custom-media --desktop-x screen and (width >= 1280px);\n  @custom-media --desktop-xl screen and (width >= 1440px);\n  @custom-media --iphone screen and (max-device-width: 736px) and (-webkit-min-device-pixel-ratio: 2);\n\n  --fontFamily: Roboto, sans-serif;\n  --mainBackground: #fff;\n  --dimBackground: #f9fafb;\n  --mainForeground: #262626;\n  --dimForeground: #6d7283;\n  --primaryForeground: #315efb;\n  --successForeground: #28bc00;\n  --warningForeground: #f4c914;\n  --failureForeground: #ff564e;\n  --lightGrayBlue: #e8eaf0;\n  --greyishBlue: #6674a6;\n  --cloudGray: #8d96b2;\n  --battleshipGrey: #62687f;\n  --carbone: #343b4c;\n}\n","@import 'utils/variables.css';\n\n.root {\n  display: flex;\n  justify-content: space-between;\n  margin-top: 20px;\n\n  @media (--mobile) {\n    flex-wrap: wrap;\n  }\n\n  & > button {\n    flex-grow: 1;\n    width: 100%;\n\n    @media (--desktop) {\n      width: calc(50% - 10px);\n    }\n  }\n\n  & > button + button {\n    @media (--mobile) {\n      margin-left: 0;\n      margin-top: 15px;\n    }\n\n    @media (--desktop) {\n      margin-left: 20px;\n      margin-top: 0;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `src-components-PopupButtons-styles--root--cwfSr`
};
module.exports = ___CSS_LOADER_EXPORT___;
